import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import NGUD from './storeModules/NGUD';
import moduleCiudad from '@/storeModules/modules/ciudad';
import moduleIndicadores from '@/storeModules/modules/indicadores';
import moduleAUE from '@/storeModules/modules/aue';
import moduleODS from '@/storeModules/modules/ods';
import moduleIndices from '@/storeModules/modules/indices';
import moduleIndicesTematicos from '@/storeModules/modules/indicesTematicos';
import moduleUsuarios from '@/storeModules/modules/usuarios';
import moduleDiagnostico from '@/storeModules/modules/diagnostico';
import moduleLoopIndicators from '@/storeModules/modules/loopIndicators';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

Vue.use(Vuex);
Vue.config.devtools = true;

const storeInstance = new Vuex.Store({
  state: {},
  actions: {},
  modules: {
    NGUD: NGUD,
    moduleCiudad,
    moduleIndicadores,
    moduleAUE,
    moduleODS,
    moduleIndices,
    moduleIndicesTematicos,
    moduleUsuarios,
    moduleDiagnostico,
    moduleLoopIndicators
  },
  mutations: {},
  plugins: [vuexLocalStorage.plugin]
});

export default function (/* { ssrContext } */) {
  const Store = storeInstance;
  return Store;
}

export { storeInstance };
